import {mapActions, mapGetters, mapMutations} from "vuex";
import {directive as onClickaway} from 'vue-clickaway';
import Vue from "vue";
import {$http} from "@/utils/https";
import carousel from "@/modules/product-card/components/carousel/index.vue";
import {minLength, maxLength, required, email} from "vuelidate/lib/validators";
import {pushFormGtmEvent} from "@/utils/formGtm";

export default {
    name: "main-header",
    components: {
        carousel
    },
    directives: {
        onClickaway: onClickaway,
    },
    data() {
        return {
            cities: [
                {id: 0, city: !this.$route.params.lang ? 'Київ' : 'Киев'},
                {id: 1, city: !this.$route.params.lang ? 'Львів' : 'Львов'},
                {id: 2, city: !this.$route.params.lang ? 'Одеса' : 'Одесса'},
                {id: 2, city: !this.$route.params.lang ? 'Харків' : 'Харьков'}],
            currentCity: '',
            searchHeightDefault: '14px',
            searchHeightActive: '25px',
            basket: localStorage.getItem('products') ? JSON.parse(localStorage.getItem('products')).length : null,
            selectedProducts: JSON.parse(localStorage.getItem('products')),
            openSidebar: false,
            params: {
                title: '',
                description: '',
                keywords: '',
                image: '',
            },
            isBasketModalOpen: false,
            showInstallmentSlider: false,
            installmentMonths: 6,
            installmentDropdownOpen: false,
            isBasketHoverActive: false,
            basketDebugEnabled: false,
            basketQuantityDrafts: {},
            basketHoverCloseTimer: null,
            basketSimilarProducts: [],
            basketSimilarLoading: false,
            isWishlistOpen: false,
            isWishlistModalOpen: false,
            wishlistItems: [],
            compareCount: 0,
            oldPriceDebugPrinted: {},
            basketOldPriceBySlug: {},
            basketOldPriceById: {},
            basketFetchInFlight: false,
            lastBasketFetchAt: 0,
            basketFetchCooldownMs: 1500,
            preloadOldPricesInFlight: false,
            preloadOldPricesRetryRequested: false,
            headerCompact: false,
            headerScrollScheduled: false,
            headerResizeTimer: null,
            headerHeightSyncTimer: null,
            isBasketOpeningLoading: false,
            wishlistCloseTimer: null,
            isCallbackPopupOpen: false,
            callbackValidationErrors: {},
            callbackPayload: {
                name: '',
                phone: '',
                email: '',
                message: '',
            },
        }
    },
    validations: {
        callbackPayload: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(20)
            },
            email: {
                maxLength: maxLength(60),
                email,
            },
            phone: {
                required,
                minLength: minLength(19),
            },
            message: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(300),
            },
        },
    },
    'head': function () {
        return {
            // canonical и hreflang выводит сервер (resources/views/front/index.blade.php
            // через App\Seo\CanonicalUrls). Здесь они строились из window.location,
            // не могли попасть в исходный HTML и на /ru/* указывали canonical
            // на украинскую версию, выбивая русский раздел из индекса.

        }

    },
    props: {
        headerData: {
            type: Array,
            default: () => [],
        }

    },
    created() {


    },
    mounted() {
        let lang = 'uk';
        try{lang = this.$route.params.lang;}catch(e){lang = 'uk'}
        if(!lang){lang = 'uk'}
        if(lang === 'uk' || lang === 'ru'){document.documentElement.setAttribute('lang',lang);}

        this.basketDebugEnabled = window.location.search.includes('basketDebug=1') || localStorage.getItem('basketDebug') === '1'
        this.logBasketDebug('mounted')
        this.setMeta()
        window.addEventListener('keydown', this.onEscapePress)
        window.addEventListener('open-basket-modal', this.handleOpenBasketModalEvent)
        document.addEventListener('click', this.onInstallmentOutsideClick)
        window.addEventListener('storage', this.onFavoritesStorage)
        window.addEventListener('favorites-updated', this.onFavoritesUpdated)
        window.addEventListener('compare-updated', this.loadCompareCount)
        this.loadWishlist()
        this.loadCompareCount()
        window.addEventListener('scroll', this.onWindowScroll, { passive: true })
        window.addEventListener('resize', this.onWindowResize)
        this.$nextTick(() => {
            this.syncHeaderCompact()
            this.initHeaderHeightObserver()
            const topEl = this.$el && this.$el.nodeType === 1 && this.$el.querySelector('.main-header__top')
            if (topEl) {
                this._headerTopEl = topEl
                topEl.addEventListener('transitionend', this.onHeaderTopTransitionEnd)
            }
        })
    },
    beforeDestroy() {
        this.logBasketDebug('beforeDestroy')
        window.removeEventListener('scroll', this.onWindowScroll)
        window.removeEventListener('resize', this.onWindowResize)
        if (this.headerResizeTimer) {
            clearTimeout(this.headerResizeTimer)
            this.headerResizeTimer = null
        }
        if (this.headerHeightSyncTimer) {
            clearTimeout(this.headerHeightSyncTimer)
            this.headerHeightSyncTimer = null
        }
        if (this._headerTopEl) {
            this._headerTopEl.removeEventListener('transitionend', this.onHeaderTopTransitionEnd)
            this._headerTopEl = null
        }
        this.destroyHeaderHeightObserver()
        document.documentElement.style.removeProperty('--main-header-height')
        window.removeEventListener('keydown', this.onEscapePress)
        window.removeEventListener('open-basket-modal', this.handleOpenBasketModalEvent)
        document.removeEventListener('click', this.onInstallmentOutsideClick)
        window.removeEventListener('storage', this.onFavoritesStorage)
        window.removeEventListener('favorites-updated', this.onFavoritesUpdated)
        window.removeEventListener('compare-updated', this.loadCompareCount)
        this.clearBasketHoverCloseTimer()
        this.clearWishlistCloseTimer()
        this.unlockPageScroll()
    },
    computed: {
        ...mapGetters({
            products: 'basket/basket',
            isAuthenticated: 'auth/isAuthenticated',
            secondBasket: 'basket/secondBasket',
            basketLoading: 'basket/basketLoading',
            feedbackLoading: 'setting/feedbackLoading',
        }),
        ...mapGetters([
            'languages',
            'currentLanguage',

        ]),
        activeSearch() {
            Vue.nextTick(() => {
                let label = this.$refs.labelSearch
            })
        },
        getTotalSum() {
            let arr = []
            if (this.products.length) {
                this.products.forEach(el => {
                    arr.push(el.quantity * el.select_type.price)
                })
            }
            return arr.reduce((partialSum, a) => partialSum + a, 0);
        },
        installmentOptions() {
            const total = this.getTotalSum
            return [3, 4, 5, 6].map(months => {
                const payment = total > 0 ? Math.ceil((total / months) * 100) / 100 : 0
                const plural = months >= 5 ? 'платежів' : 'платежі'
                const label = `${months} ${plural} — ${this.formatMiniMoney(payment)} ₴/міс`
                return {months, payment, label}
            })
        },
        selectedInstallmentLabel() {
            const opt = this.installmentOptions.find(o => o.months === this.installmentMonths)
            return opt ? opt.label : ''
        },
        getBasketDiscountTotal() {
            if (!Array.isArray(this.products) || !this.products.length) {
                return 0
            }
            return this.products.reduce((sum, item) => {
                const oldTotal = this.getMiniOldTotal(item)
                const currentTotal = this.getMiniCurrentTotal(item)
                if (!oldTotal || oldTotal <= currentTotal) {
                    return sum
                }
                return sum + (oldTotal - currentTotal)
            }, 0)
        },
        getBasketTotalWithoutDiscount() {
            return this.getTotalSum + this.getBasketDiscountTotal
        },
        isProfileRoute() {
            // Проверяем имя роута для profile страниц
            const profileRouteNames = ['profile', 'user-info', 'bonuses', 'orders', 'history', 'accounts', 'accounts-item', 'catalog', 'profile-constructor', 'profile-snow-load', 'profile-calculator'];
            if (this.$route.name && (this.$route.name === 'profile' || this.$route.name.startsWith('profile-') || profileRouteNames.includes(this.$route.name))) {
                return true;
            }
            // Проверяем путь, но исключаем manuals
            if (this.$route.path && this.$route.path.includes('/profile') && !this.$route.path.includes('/manuals')) {
                // Проверяем, что /profile идет как отдельный сегмент пути
                const pathSegments = this.$route.path.split('/');
                const profileIndex = pathSegments.indexOf('profile');
                // Если profile найден и это не последний сегмент (что означало бы, что это часть slug)
                if (profileIndex !== -1 && profileIndex < pathSegments.length - 1) {
                    return true;
                }
                // Если путь начинается с /profile
                if (this.$route.path.startsWith('/profile')) {
                    return true;
                }
            }
            return false;
        },
        wishlistCount() {
            return this.wishlistItems.length
        },
        callbackNameErrors() {
            const error = [];
            if (!this.$v.callbackPayload.name.$dirty) {
                return error;
            }
            if (!this.$v.callbackPayload.name.required) {
                error.push(this.$t('validation.required'))
            }
            if (!this.$v.callbackPayload.name.minLength) {
                error.push(this.$t('validation.minLength', {'size': 3}));
            }
            if (!this.$v.callbackPayload.name.maxLength) {
                error.push(this.$t('validation.maxLength', {'size': 20}));
            }
            if (this.callbackValidationErrors.name) {
                this.callbackValidationErrors.name.forEach((row) => {
                    error.push(row);
                })
            }
            return error;
        },
        callbackPhoneErrors() {
            const error = [];
            if (!this.$v.callbackPayload.phone.$dirty) {
                return error;
            }
            if (!this.$v.callbackPayload.phone.required) {
                error.push(this.$t('validation.required'))
            }
            if (!this.$v.callbackPayload.phone.minLength) {
                error.push(this.$t('validation.minLength', {'size': 11}));
            }
            if (this.callbackValidationErrors.phone) {
                this.callbackValidationErrors.phone.forEach((row) => {
                    error.push(row);
                })
            }
            return error;
        },
        callbackEmailErrors() {
            const error = [];
            if (!this.$v.callbackPayload.email.$dirty) {
                return error;
            }
            if (!this.$v.callbackPayload.email.maxLength) {
                error.push(this.$t('validation.maxLength', {'size': 50}));
            }
            if (!this.$v.callbackPayload.email.email) {
                error.push(this.$t('validation.email'))
            }
            if (this.callbackValidationErrors.email) {
                this.callbackValidationErrors.email.forEach((row) => {
                    error.push(row);
                });
            }
            return error;
        },
        callbackMessageErrors() {
            const error = [];
            if (!this.$v.callbackPayload.message.$dirty) {
                return error;
            }
            if (!this.$v.callbackPayload.message.required) {
                error.push(this.$t('validation.required'))
            }
            if (!this.$v.callbackPayload.message.minLength) {
                error.push(this.$t('validation.minLength', {'size': 12}));
            }
            if (!this.$v.callbackPayload.message.maxLength) {
                error.push(this.$t('validation.maxLength', {'size': 300}));
            }
            if (this.callbackValidationErrors.message) {
                this.callbackValidationErrors.message.forEach((row) => {
                    error.push(row);
                })
            }
            return error;
        }
    },
    watch: {
        'products': function () {
            this.basket = JSON.parse(localStorage.getItem('products')) ? JSON.parse(localStorage.getItem('products')).length : null
            this.selectedProducts = JSON.parse(localStorage.getItem('products'))
            this.syncBasketQuantityDrafts()
            this.preloadBasketOldPrices().catch(() => {})
        },
        '$route'() {
            // this.setMeta()
            this.logBasketDebug('route changed', {name: this.$route.name, path: this.$route.path})
            if (this.isBasketModalOpen) {
                this.closeBasketModal()
            }
            if (this.isWishlistModalOpen) {
                this.closeWishlistModal()
            }
            if (this.isCallbackPopupOpen) {
                this.closeCallbackPopup()
            }
            this.isWishlistOpen = false
            this.$nextTick(() => {
                this.syncHeaderCompact()
            })
        },
        product: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.setMeta()
                }
            }
        }
    },
    methods: {
        ...mapMutations({
            closeRegisterPopup: 'auth/SHOW_REGISTER_POPUP',
            isShowAuthPopup: 'auth/SHOW_AUTH_POPUP',
            removeProduct: 'basket/REMOVE_ITEM_FROM_BASKET',
            increment: 'basket/INCREMENT_BASKET_LIST_COUNT',
            decrement: 'basket/DECREMENT_BASKET_LIST_COUNT',
            setCount: 'basket/SET_BASKET_LIST_COUNT',
        }),
        ...mapActions({
            getBasket: 'basket/GET_BASKET',
            sendBasket: 'basket/UPDATE_BASKET',
            basketProductAction: 'basket/BASKET_PRODUCT_ACTION',
            sendFeedBack: 'setting/SEND_FEEDBACK',
        }),
        openCallbackPopup() {
            this.isCallbackPopupOpen = true
            this.callbackValidationErrors = {}
        },
        closeCallbackPopup() {
            this.isCallbackPopupOpen = false
            if (!this.isBasketModalOpen && !this.isWishlistModalOpen && !this.openSidebar) {
                this.unlockPageScroll()
            }
        },
        resetCallbackPayload() {
            this.callbackPayload = {
                name: '',
                phone: '',
                email: '',
                message: '',
            }
            this.callbackValidationErrors = {}
            this.$nextTick(() => {
                if (this.$v && this.$v.callbackPayload) {
                    this.$v.callbackPayload.$reset()
                }
            })
        },
        submitCallbackForm() {
            this.$v.callbackPayload.$touch();
            this.callbackValidationErrors = {}
            if (this.$v.callbackPayload.$invalid) {
                return
            }
            const obj = {
                name: this.callbackPayload.name,
                email: this.callbackPayload.email,
                message: this.callbackPayload.message,
                type: 'callback',
                phone: this.callbackPayload.phone.replace(/[^\d]/g, ''),
                page_url: typeof window !== 'undefined' ? window.location.href : '',
            }
            this.sendFeedBack(obj)
                .then(() => {
                    pushFormGtmEvent('main_callback_form', {
                        phone_number: obj.phone,
                        email: obj.email,
                    });
                    this.$toasted.success(this.$t('form.send'));
                    this.resetCallbackPayload()
                    this.closeCallbackPopup()
                })
                .catch(() => {
                    this.$toasted.error(this.$t('form.sendError'));
                })
        },
        onFavoritesStorage(event) {
            if (event.key === 'favorites') {
                this.loadWishlist()
            }
            if (event.key === 'productCompare') {
                this.loadCompareCount()
            }
        },
        onFavoritesUpdated() {
            this.loadWishlist()
        },
        loadWishlist() {
            try {
                const list = JSON.parse(localStorage.getItem('favorites'))
                this.wishlistItems = Array.isArray(list) ? list : []
            } catch (e) {
                this.wishlistItems = []
            }
        },
        loadCompareCount() {
            try {
                const list = JSON.parse(localStorage.getItem('productCompare'))
                this.compareCount = Array.isArray(list) ? list.length : 0
            } catch (e) {
                this.compareCount = 0
            }
        },
        onWindowScroll() {
            if (this.headerScrollScheduled) {
                return
            }
            this.headerScrollScheduled = true
            requestAnimationFrame(() => {
                this.headerScrollScheduled = false
                this.syncHeaderCompact()
            })
        },
        onWindowResize() {
            clearTimeout(this.headerResizeTimer)
            this.headerResizeTimer = setTimeout(() => {
                this.headerResizeTimer = null
                this.syncHeaderCompact()
            }, 120)
        },
        syncHeaderCompact() {
            if (typeof window === 'undefined' || !this.$el || this.$el.nodeType !== 1) {
                return
            }
            if (window.innerWidth <= 1100) {
                if (this.headerCompact) {
                    this.headerCompact = false
                }
                document.documentElement.style.removeProperty('--main-header-height')
                return
            }
            const y = window.pageYOffset || document.documentElement.scrollTop || 0
            const compact = y > 32
            if (this.headerCompact !== compact) {
                this.headerCompact = compact
            }
            this.scheduleMainHeaderHeightUpdate()
        },
        scheduleMainHeaderHeightUpdate() {
            this.$nextTick(() => {
                this.updateMainHeaderHeightVar()
                clearTimeout(this.headerHeightSyncTimer)
                this.headerHeightSyncTimer = setTimeout(() => {
                    this.headerHeightSyncTimer = null
                    this.updateMainHeaderHeightVar()
                }, 360)
            })
        },
        onHeaderTopTransitionEnd(e) {
            if (
                e.target.classList &&
                e.target.classList.contains('main-header__top') &&
                (e.propertyName === 'max-height' || e.propertyName === 'opacity')
            ) {
                this.updateMainHeaderHeightVar()
            }
        },
        initHeaderHeightObserver() {
            if (typeof ResizeObserver === 'undefined' || !this.$el || this.$el.nodeType !== 1) {
                return
            }
            this.destroyHeaderHeightObserver()
            this._headerResizeObserver = new ResizeObserver(() => {
                this.updateMainHeaderHeightVar()
            })
            this._headerResizeObserver.observe(this.$el)
        },
        destroyHeaderHeightObserver() {
            if (this._headerResizeObserver) {
                this._headerResizeObserver.disconnect()
                this._headerResizeObserver = null
            }
        },
        updateMainHeaderHeightVar() {
            if (typeof document === 'undefined') {
                return
            }
            const el = this.$el
            if (!el || el.nodeType !== 1) {
                return
            }
            if (window.innerWidth <= 1100) {
                document.documentElement.style.removeProperty('--main-header-height')
                return
            }
            const h = Math.round(el.getBoundingClientRect().height)
            if (h > 0) {
                document.documentElement.style.setProperty('--main-header-height', `${h}px`)
            }
        },
        clearWishlistCloseTimer() {
            if (this.wishlistCloseTimer) {
                clearTimeout(this.wishlistCloseTimer)
                this.wishlistCloseTimer = null
            }
        },
        openWishlistHover() {
            this.loadWishlist()
            this.clearWishlistCloseTimer()
            this.isWishlistOpen = true
        },
        scheduleWishlistClose() {
            this.clearWishlistCloseTimer()
            this.wishlistCloseTimer = setTimeout(() => {
                this.isWishlistOpen = false
                this.wishlistCloseTimer = null
            }, 150)
        },
        closeWishlist() {
            this.clearWishlistCloseTimer()
            this.isWishlistOpen = false
        },
        openWishlistFromBurger() {
            this.loadWishlist()
            this.closeMenu()
            this.isWishlistModalOpen = true
            this.lockPageScroll()
        },
        closeWishlistModal() {
            this.isWishlistModalOpen = false
            if (!this.isBasketModalOpen && !this.openSidebar) {
                this.unlockPageScroll()
            }
        },
        removeWishlistItem(id) {
            const nextList = this.wishlistItems.filter((item) => String(item.id) !== String(id))
            localStorage.setItem('favorites', JSON.stringify(nextList))
            this.wishlistItems = nextList
            window.dispatchEvent(new CustomEvent('favorites-updated'))
        },
        getBasketItemDraftKey(item) {
            return `${item?.id}-${item?.select_type?.id}`
        },
        syncBasketQuantityDrafts() {
            const drafts = {}
            if (Array.isArray(this.selectedProducts)) {
                this.selectedProducts.forEach(item => {
                    drafts[this.getBasketItemDraftKey(item)] = item.quantity
                })
            }
            this.basketQuantityDrafts = drafts
        },
        getDraftQuantity(item) {
            const key = this.getBasketItemDraftKey(item)
            if (typeof this.basketQuantityDrafts[key] === 'undefined') {
                this.$set(this.basketQuantityDrafts, key, item.quantity)
            }
            return this.basketQuantityDrafts[key]
        },
        onBasketQuantityInput(item, event) {
            const key = this.getBasketItemDraftKey(item)
            const parsed = parseInt(event.target.value, 10)
            this.$set(this.basketQuantityDrafts, key, Number.isNaN(parsed) ? '' : parsed)
        },
        applyBasketQuantity(item) {
            const key = this.getBasketItemDraftKey(item)
            const rawValue = this.basketQuantityDrafts[key]
            const count = parseInt(rawValue, 10)
            if (Number.isNaN(count) || count < 1) {
                this.$set(this.basketQuantityDrafts, key, 1)
                this.changeBasketCount(item, 'set_count', 1)
                return
            }
            this.changeBasketCount(item, 'set_count', count)
        },
        getProductIdForApi(item) {
            return item?.select_type?.id || item?.id
        },
        canEditQuantity(item) {
            const discount = item?.select_type?.discount || {}
            return !!(item?.select_type && !item.select_type.isGiftProduct && !discount.hasText && discount.typeNumber !== 1)
        },
        onInstallmentOutsideClick(e) {
            if (this.installmentDropdownOpen && this.$refs.installmentDropdown && !this.$refs.installmentDropdown.contains(e.target)) {
                this.installmentDropdownOpen = false
            }
        },
        formatMiniMoney(value) {
            const numeric = Number(value) || 0
            return new Intl.NumberFormat('uk').format(Number(numeric.toFixed(2)))
        },
        parseMoneyValue(value) {
            if (value === null || typeof value === 'undefined') {
                return 0
            }
            if (typeof value === 'number') {
                return value
            }
            const normalized = String(value)
                .replace(/\s/g, '')
                .replace(',', '.')
                .replace(/[^\d.-]/g, '')
            const parsed = Number(normalized)
            return Number.isFinite(parsed) ? parsed : 0
        },
        getMiniUnitPrice(item) {
            const st = item?.select_type || {}
            // In basket row we display st.price, so use same source for consistency.
            const directBasketPrice = this.parseMoneyValue(st?.price)
            if (directBasketPrice > 0) {
                return directBasketPrice
            }
            const productPrice = st?.productPrice
            if (productPrice?.price) {
                const parsedPrice = this.parseMoneyValue(productPrice.price?.price)
                if (parsedPrice > 0) {
                    return parsedPrice
                }
                const parsedPriceM2 = this.parseMoneyValue(productPrice.price?.priceM2)
                if (parsedPriceM2 > 0) {
                    return parsedPriceM2
                }
            }
            return 0
        },
        getMiniCurrentTotal(item) {
            return this.getMiniUnitPrice(item) * (Number(item?.quantity) || 1)
        },
        getMiniOldUnitPrice(item) {
            const st = item?.select_type || {}
            const productPrice = st?.productPrice

            // Hard priority: old price in the same unit as basket row (price per item/list).
            if (productPrice?.hasDiscount && productPrice?.priceOld) {
                const parsedOldPrice = this.parseMoneyValue(productPrice.priceOld?.price)
                if (parsedOldPrice > 0) {
                    return parsedOldPrice
                }
            }

            const slug = st?.slug
            if (slug && typeof this.basketOldPriceBySlug[slug] !== 'undefined') {
                const cachedOld = this.parseMoneyValue(this.basketOldPriceBySlug[slug])
                if (cachedOld > 0) {
                    return cachedOld
                }
            }
            const productId = st?.id || item?.id
            if (productId && typeof this.basketOldPriceById[productId] !== 'undefined') {
                const cachedOldById = this.parseMoneyValue(this.basketOldPriceById[productId])
                if (cachedOldById > 0) {
                    return cachedOldById
                }
            }

            const directCandidates = [
                st?.productPrice?.priceOld?.price,
                st?.productPrice?.oldPrice?.price,
                st?.total?.wrapper?.discount,
                st?.totalWrapper?.discount,
                st?.total__wrapper_discount,
                st?.['total__wrapper-discount'],
                st?.priceOld,
                st?.oldPrice,
                st?.discountPrice,
                st?.discount_price,
                st?.price_old,
                st?.discount?.oldPrice,
                st?.discount?.old_price,
                st?.discount?.priceOld,
                st?.discount?.price_old
            ]
            for (const candidate of directCandidates) {
                const parsed = this.parseMoneyValue(candidate)
                if (parsed > 0) {
                    return parsed
                }
            }

            // Fallback: try derive old price from discount percent text like "-10%"
            const discountText = st?.discount?.text || ''
            const percentMatch = String(discountText).match(/(\d+(?:[.,]\d+)?)\s*%/)
            if (percentMatch) {
                const percent = this.parseMoneyValue(percentMatch[1])
                const currentPrice = this.getMiniUnitPrice(item)
                if (percent > 0 && percent < 100 && currentPrice > 0) {
                    const derived = currentPrice / (1 - percent / 100)
                    if (Number.isFinite(derived) && derived > currentPrice) {
                        return derived
                    }
                }
            }

            this.logOldPriceDebug(item, directCandidates)
            return 0
        },
        async preloadBasketOldPrices() {
            if (this.preloadOldPricesInFlight) {
                this.preloadOldPricesRetryRequested = true
                return
            }
            const products = Array.isArray(this.selectedProducts) ? this.selectedProducts : []
            const slugTasks = [...new Set(products
                .map(item => item?.select_type?.slug)
                .filter(Boolean))]
            const fallbackIdTasks = [...new Set(products
                .filter(item => !item?.select_type?.slug)
                .map(item => item?.select_type?.id || item?.id)
                .filter(Boolean))]

            if (!slugTasks.length && !fallbackIdTasks.length) {
                return
            }

            this.preloadOldPricesInFlight = true
            try {
                // avoid API burst: run in a small sequential queue
                for (const slug of slugTasks) {
                    if (typeof this.basketOldPriceBySlug[slug] !== 'undefined') {
                        continue
                    }
                    try {
                        const response = await $http.get(`v1/catalog/product/${slug}`)
                        const product = response?.data?.data || {}
                        const pp = product?.productPrice || {}
                        const oldPriceValue = pp?.priceOld?.price
                        const parsed = this.parseMoneyValue(oldPriceValue)
                        this.$set(this.basketOldPriceBySlug, slug, parsed > 0 ? parsed : null)
                    } catch (e) {
                        this.$set(this.basketOldPriceBySlug, slug, null)
                    }
                }

                for (const productId of fallbackIdTasks) {
                    if (typeof this.basketOldPriceById[productId] !== 'undefined') {
                        continue
                    }
                    try {
                        const response = await $http.get(`v1/catalog/products/${productId}/price`)
                        const payload = response?.data?.data || response?.data || {}
                        const parsed = this.parseMoneyValue(
                            payload?.priceOld?.price ||
                            payload?.oldPrice?.price
                        )
                        this.$set(this.basketOldPriceById, productId, parsed > 0 ? parsed : null)
                    } catch (e) {
                        this.$set(this.basketOldPriceById, productId, null)
                    }
                }
            } finally {
                this.preloadOldPricesInFlight = false
                if (this.preloadOldPricesRetryRequested) {
                    this.preloadOldPricesRetryRequested = false
                    this.preloadBasketOldPrices().catch(() => {})
                }
            }
        },
        async fetchBasketSafely(force = false) {
            const now = Date.now()
            if (this.basketFetchInFlight) {
                return
            }
            if (!force && now - this.lastBasketFetchAt < this.basketFetchCooldownMs) {
                return
            }
            this.basketFetchInFlight = true
            this.lastBasketFetchAt = now
            try {
                await this.getBasket()
            } catch (e) {
                this.logBasketDebug('getBasket failed', {status: e?.response?.status})
            } finally {
                this.basketFetchInFlight = false
            }
        },
        hasProductInBasket(productId) {
            if (!productId || !Array.isArray(this.products)) {
                return false
            }
            const targetId = String(productId)
            return this.products.some((item) => {
                const id = item?.select_type?.id || item?.id
                return String(id) === targetId
            })
        },
        wait(ms) {
            return new Promise((resolve) => {
                setTimeout(resolve, ms)
            })
        },
        async openBasketModalWhenProductReady(productId) {
            if (this.isBasketOpeningLoading || this.isBasketModalOpen) {
                return
            }
            this.isBasketOpeningLoading = true
            this.lockPageScroll()
            const maxAttempts = 8
            try {
                for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
                    await this.fetchBasketSafely(true)
                    if (this.hasProductInBasket(productId)) {
                        break
                    }
                    await this.wait(220)
                }
                this.openBasketModal()
            } finally {
                this.isBasketOpeningLoading = false
                if (!this.isBasketModalOpen && !this.openSidebar) {
                    this.unlockPageScroll()
                }
            }
        },
        logOldPriceDebug(item, directCandidates = []) {
            const productId = item?.select_type?.id || item?.id
            if (!productId || this.oldPriceDebugPrinted[productId]) {
                return
            }
            this.$set(this.oldPriceDebugPrinted, productId, true)
        },
        getMiniOldTotal(item) {
            const oldPrice = this.getMiniOldUnitPrice(item)
            const current = this.getMiniUnitPrice(item)
            if (!oldPrice || Math.abs(oldPrice - current) <= 0.01) {
                return null
            }
            return oldPrice * (Number(item?.quantity) || 1)
        },
        async debugBasketProductsData() {
            if (!this.basketDebugEnabled) {
                return
            }
            const products = Array.isArray(this.selectedProducts) ? this.selectedProducts : []
            console.group('[BasketDebugFull] cart snapshot')
            console.log('count:', products.length)
            console.log('items:', products)
            console.groupEnd()

            if (!products.length) {
                return
            }

            const requests = products.map(async (item, index) => {
                const selectType = item?.select_type || {}
                const slug = selectType?.slug
                const productId = selectType?.id || item?.id

                console.group(`[BasketDebugFull] item #${index + 1}`)
                console.log('basketItem:', item)
                console.log('selectType:', selectType)
                console.log('priceCalculated:', {
                    unitPrice: this.getMiniUnitPrice(item),
                    oldUnitPrice: this.getMiniOldUnitPrice(item),
                    oldTotal: this.getMiniOldTotal(item),
                    currentTotal: this.getMiniCurrentTotal(item),
                    quantity: item?.quantity
                })

                if (!slug) {
                    console.warn('No slug, skip API fetch')
                    console.groupEnd()
                    return
                }

                try {
                    const response = await $http.get(`v1/catalog/product/${slug}`)
                    const data = response?.data?.data || response?.data
                    console.log('api.product.full:', data)
                    console.log('api.product.price-parts:', {
                        productPrice: data?.productPrice,
                        total: data?.total,
                        discount: data?.discount
                    })
                } catch (e) {
                    console.error('api fetch failed', {slug, productId, error: e})
                } finally {
                    console.groupEnd()
                }
            })

            await Promise.allSettled(requests)
        },
        async fetchBasketSimilarProducts() {
            const baseProduct = (this.selectedProducts || []).find(item => item?.select_type?.slug && !item?.select_type?.isGiftProduct)
            if (!baseProduct) {
                this.basketSimilarProducts = []
                return
            }
            this.basketSimilarLoading = true
            try {
                const response = await $http.get(`v1/catalog/product/${baseProduct.select_type.slug}`)
                const similar = response?.data?.data?.similar?.data || []
                this.basketSimilarProducts = similar.filter(product =>
                    !this.selectedProducts.some(selected => selected?.select_type?.id === product?.id)
                )
            } catch (e) {
                this.basketSimilarProducts = []
            } finally {
                this.basketSimilarLoading = false
            }
        },
        changeBasketCount(item, type, manualCount = null) {
            if (this.basketLoading) {
                return
            }
            const productIdForApi = this.getProductIdForApi(item)
            if (!productIdForApi) {
                return
            }
            if (type === 'increment') {
                this.increment(item)
                const key = this.getBasketItemDraftKey(item)
                this.$set(this.basketQuantityDrafts, key, item.quantity + 1)
                this.basketProductAction({type: 'increment', product_id: productIdForApi})
                return
            }
            if (type === 'decrement') {
                if (item.quantity <= 1) {
                    this.changeBasketCount(item, 'delete')
                    return
                }
                this.decrement(item)
                const key = this.getBasketItemDraftKey(item)
                this.$set(this.basketQuantityDrafts, key, item.quantity - 1)
                this.basketProductAction({type: 'decrement', product_id: productIdForApi})
                return
            }
            if (type === 'delete') {
                this.removeProduct(item)
                const key = this.getBasketItemDraftKey(item)
                this.$delete(this.basketQuantityDrafts, key)
                this.basketProductAction({type: 'delete', product_id: productIdForApi})
                return
            }
            if (type === 'set_count') {
                const normalizedCount = Math.max(1, parseInt(manualCount, 10) || 1)
                const key = this.getBasketItemDraftKey(item)
                this.$set(this.basketQuantityDrafts, key, normalizedCount)
                const obj = {
                    id: item.id,
                    quantity: normalizedCount,
                    select_type: item.select_type
                }
                this.setCount(obj)
                this.basketProductAction({
                    type: 'set_count',
                    product_id: productIdForApi,
                    count: normalizedCount
                })
            }
        },
        logBasketDebug(event, payload = {}) {
            if (!this.basketDebugEnabled) {
                return
            }
            const now = new Date().toISOString()
            console.log('[BasketDebug]', {
                now,
                event,
                routeName: this.$route && this.$route.name,
                modalOpen: this.isBasketModalOpen,
                hoverOpen: this.isBasketHoverActive,
                ...payload
            })
        },
        setMeta() {
            this.$emit('updateHead');
        },
        changeLanguage(code) {
            this.$setLanguage(code).then(data => {
                window.location.reload();
            });
        },
        searchFocus() {
            let close = this.$refs["closeIcon"]
            let searchWrapper = this.$refs["searchWrapper"]
            searchWrapper.classList.add('search-expanded')
            this.$refs["search"].addEventListener('transitionend', function () {
                close.style.display = 'block'
            })
            let search = this.$refs["search"].style
            search.height = this.searchHeightActive
            searchWrapper.style.position = 'absolute'
            searchWrapper.style.bottom = '-12px'
            search.transition = '0.3s linear'

            let callBack = this.$refs["callBack"].style
            callBack.opacity = '0'
            callBack.transition = '0.3s linear'

            let searchResult = this.$refs["searchResult"].style
            setTimeout(function () {
                searchResult.opacity = '1'
                searchResult.transition = '0.3s linear'
            }, 1000);

        },
        openBasket() {
            this.openBasketModal()
        },
        openBasketPreview() {
            this.clearBasketHoverCloseTimer()
            this.logBasketDebug('openBasketPreview called', {width: window.innerWidth})
            if (this.isBasketModalOpen || window.innerWidth <= 1100) {
                this.logBasketDebug('openBasketPreview blocked')
                return
            }
            this.fetchBasketSafely().catch(() => {})
            this.isBasketHoverActive = true
            this.logBasketDebug('hover opened')
            this.$nextTick(() => {
                this.preloadBasketOldPrices().catch(() => {})
                if (this.basketDebugEnabled) {
                    this.debugBasketProductsData()
                }
            })
        },
        closeBasketPreview() {
            this.logBasketDebug('closeBasketPreview scheduled')
            if (this.isBasketModalOpen) {
                this.logBasketDebug('closeBasketPreview blocked: modal open')
                return
            }
            this.scheduleBasketPreviewClose()
        },
        scheduleBasketPreviewClose() {
            this.clearBasketHoverCloseTimer()
            this.basketHoverCloseTimer = setTimeout(() => {
                if (!this.isBasketModalOpen) {
                    this.isBasketHoverActive = false
                    this.logBasketDebug('hover closed by timer')
                }
                this.basketHoverCloseTimer = null
            }, 220)
        },
        clearBasketHoverCloseTimer() {
            if (this.basketHoverCloseTimer) {
                clearTimeout(this.basketHoverCloseTimer)
                this.basketHoverCloseTimer = null
            }
        },
        lockPageScroll() {
            const html = document.getElementById('html')
            if (html) {
                html.classList.add('hide')
            }
        },
        unlockPageScroll() {
            const html = document.getElementById('html')
            if (html) {
                html.classList.remove('hide')
            }
        },
        openBasketModal() {
            this.logBasketDebug('openBasketModal called')
            if (this.isBasketModalOpen) {
                this.logBasketDebug('openBasketModal blocked: already open')
                return
            }
            this.clearBasketHoverCloseTimer()
            this.isBasketHoverActive = false
            this.isBasketModalOpen = true
            this.lockPageScroll()
            this.logBasketDebug('modal opened')
            this.$nextTick(() => {
                this.fetchBasketSafely(true).catch(() => {})
                this.fetchBasketSimilarProducts()
                this.preloadBasketOldPrices().catch(() => {})
                if (this.basketDebugEnabled) {
                    this.debugBasketProductsData()
                }
            })
        },
        closeBasketModal() {
            this.logBasketDebug('closeBasketModal called')
            this.isBasketModalOpen = false
            this.showInstallmentSlider = false
            this.installmentMonths = 6
            this.installmentDropdownOpen = false
            if (!this.isWishlistModalOpen && !this.openSidebar) {
                this.unlockPageScroll()
            }
            this.logBasketDebug('modal closed')
        },
        onEscapePress(event) {
            if (event.key === 'Escape' && this.isBasketModalOpen) {
                this.logBasketDebug('escape close')
                this.closeBasketModal()
                return
            }
            if (event.key === 'Escape' && this.isWishlistModalOpen) {
                this.closeWishlistModal()
                return
            }
            if (event.key === 'Escape' && this.isCallbackPopupOpen) {
                this.closeCallbackPopup()
            }
        },
        handleOpenBasketModalEvent(event) {
            const productId = event?.detail?.productId
            const installment = event?.detail?.installment || false
            if (installment) {
                this.showInstallmentSlider = true
            }
            if (productId) {
                this.openBasketModalWhenProductReady(productId)
                return
            }
            this.openBasketModal()
        },
        openMenu() {
            this.openSidebar = !this.openSidebar
            const htmlOverlay = document.getElementById('html-overlay')
            if (this.openSidebar) {
                this.lockPageScroll()
                if (htmlOverlay) {
                    htmlOverlay.classList.add('html-overlay')
                }
                return
            }
            if (!this.isBasketModalOpen && !this.isWishlistModalOpen) {
                this.unlockPageScroll()
            }
            if (htmlOverlay) {
                htmlOverlay.classList.remove('html-overlay')
            }
        },
        goToLK() {

            if (!this.isAuthenticated) {
                this.closeRegisterPopup(true)
            } else {
                this.$router.push({name: 'profile'}).catch(() => {
                    console.log()
                })
            }
        },
        goAuthPopup(){
            if (!this.isAuthenticated) {
                this.closeRegisterPopup(false)
                this.isShowAuthPopup(true)
            } else {
                this.$router.push({name: 'profile'}).catch(() => {
                    console.log()
                })
            }
        },
        closePopUp() {
            this.clearBasketHoverCloseTimer()
            this.isBasketHoverActive = false
            this.logBasketDebug('closePopUp')
        },
        redirectToBasket() {
            this.logBasketDebug('redirectToBasket')
            this.clearBasketHoverCloseTimer()
            this.isBasketHoverActive = false
            this.isBasketModalOpen = false
            this.unlockPageScroll()
            this.$router.push({name: 'basket'}).catch(() => {
                console.log()
            })
        },
        openBasketModalFromMini() {
            this.logBasketDebug('openBasketModalFromMini')
            this.clearBasketHoverCloseTimer()
            this.isBasketHoverActive = false
            this.openBasketModal()
        },
        goToOrderingFromMini() {
            this.closePopUp()
            this.$router.push({name: 'ordering'}).catch(() => {
                console.log()
            })
        },
        goToOrderingFromModal() {
            this.closeBasketModal()
            this.$router.push({name: 'ordering'}).catch(() => {
                console.log()
            })
        },
        goToOrderingWithInstallment() {
            try {
                localStorage.setItem('installment_months', String(this.installmentMonths))
            } catch (e) {}
            this.closeBasketModal()
            this.$router.push({name: 'ordering'}).catch(() => {})
        },
        goToOrderingFromBurger() {
            this.closeMenu()
            this.$router.push({name: 'ordering'}).catch(() => {
                console.log()
            })
        },
        away: function () {
            this.clearBasketHoverCloseTimer()
            this.isBasketHoverActive = false
            this.logBasketDebug('clickaway close hover')
        },
        closeMenu: function () {
            this.openSidebar = false
            if (!this.isBasketModalOpen && !this.isWishlistModalOpen) {
                this.unlockPageScroll()
            }
            const htmlOverlay = document.getElementById('html-overlay')
            if (htmlOverlay) {
                htmlOverlay.classList.remove('html-overlay')
            }
        },

        anchorScroll(item) {
            // this.openMenu()
            // document.getElementById('html-overlay').classList.toggle('html-overlay')
            item = document.getElementById('calBack')

            if (item === null) {

                this.$router.push({name: 'home'}).then(() => {
                    const myEl = document.getElementById('calBack')
                    this.$smoothScroll({
                        scrollTo: myEl,
                    })
                }).catch(() => {
                    const myEl = document.getElementById('calBack')
                    this.$smoothScroll({
                        scrollTo: myEl,
                    })
                    console.log()
                })
            } else {

                const myEl = document.getElementById('calBack')
                this.$smoothScroll({
                    scrollTo: myEl,
                })
            }

        },
    },
}
